import React from 'react';
import { Observe } from 'rewire-core';
import { Modal, WithStyle, FormView } from 'rewire-ui';
import { Theme } from '@material-ui/core/styles';
import DraggableResizableDialog2 from '../ui/DraggableResizableDialog2';
import TitleWithFlowLogo from '../ui/TitleWithFlowLogo';
import inviteDialogModel from './InviteDialogModel';
import BillingLinkDialog from './BillingLinkDialog';
import { withStyles } from '../utility/styles';

const styles = (_theme: Theme) => ({});

interface IInviteDialogProps {}

type InviteDialogProps = WithStyle<ReturnType<typeof styles>, IInviteDialogProps>;

class InviteDialog extends React.PureComponent<InviteDialogProps> {
  constructor(props: InviteDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    inviteDialogModel.reset();
  }

  renderTitle = (_dialog: Modal): JSX.Element => {
    return <TitleWithFlowLogo beforeText="Invite People to" />;
  };

  renderDialogContents = React.memo((): JSX.Element => {
    return (
      <Observe
        render={() => (
          <FormView form={inviteDialogModel.form} onSubmit={inviteDialogModel.actionFn('send invite')}>
            <div className="content">
              <inviteDialogModel.form.field.email.Editor className="span1" />
            </div>
            <div className="content">
              <inviteDialogModel.form.field.role.Editor className="span1" />
            </div>
          </FormView>
        )}
      />
    );
  });

  render() {
    return (
      <Observe
        render={() => (
          <>
            <DraggableResizableDialog2
              defaultWidth="xs"
              DialogProps={{ dialog: inviteDialogModel, title: this.renderTitle, disableEscapeKeyDown: false }}
              DraggableResizableBoxProps={{ minWidth: '315px', minHeight: '306px' }}
            >
              <this.renderDialogContents />
            </DraggableResizableDialog2>
            <BillingLinkDialog />
          </>
        )}
      />
    );
  }
}

export default withStyles<IInviteDialogProps>(styles, InviteDialog);
